/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-array-index-key */
import moment from 'moment-timezone';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { getOverdueClients } from '../app/store/actions/overdueClients';
import itemsPage from '../data/itemsPage';

import Table from '../components/table/table';

class OverdueClients extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      limit: itemsPage.page.limit,
      page: 1,
      orderBy: 'DESC',
      overdueClientsData: [],
      search: '',
      total: 0,
    };
  }

  componentDidMount() {
    this.searchOverdueClients();
  }

  searchOverdueClients = async () => {
    const {
      page, limit, orderBy, search,
    } = this.state;

    await this.props.getOverdueClients({
      page,
      limit,
      orderBy,
      search,
    });

    const { overdueClients } = this.props;

    if (overdueClients && overdueClients.data) {
      this.setState({
        overdueClientsData: overdueClients.data.rows || overdueClients.data,
        total: overdueClients.data.count || overdueClients.data.length || 0,
      });
    }
  };

  updateValues = async (search = '', pages = 1) => {
    await this.setState({
      search,
      page: pages,
    });

    this.searchOverdueClients();
  };

  sortTable = async (field, orderBy) => {
    await this.setState({
      field,
      orderBy,
      page: 1,
    });

    this.searchOverdueClients();
  };

  render() {
    const {
      limit, page, overdueClientsData, total,
    } = this.state;

    const tableHeader = [
      { key: 'clientName', value: I18n.t('client') },
      { key: 'clientNickname', value: I18n.t('nickname') },
      { key: 'cnpj', value: I18n.t('cnpj') },
      { key: 'userName', value: I18n.t('user') },
      { key: 'userEmail', value: I18n.t('email') },
      { key: 'situation', value: I18n.t('situation') },
      { key: 'lastAccess', value: I18n.t('lastAccess') },
    ];

    const tableData = (overdueClientsData || []).map((row, index) => ({
      key: index,
      clientId: row.clientId,
      clientName: row.clientName || '-',
      clientNickname: row.clientNickname || '-',
      cnpj: row.cnpj || '-',
      userName: row.userName || '-',
      userEmail: row.userEmail || '-',
      situation: row.situation || '-',
      lastAccess: row.lastAccess
        ? moment(row.lastAccess).format('DD/MM/YYYY HH:mm')
        : '-',
    }));

    return (
      <div className="main-div-tables">
        <Table
          title={I18n.t('overdueClients')}
          header={tableHeader}
          lines={tableData}
          page={page}
          perPage={limit}
          count={total}
          searchItems={this.updateValues}
          showItemsCount
          sortTable={this.sortTable}
          placeholderSearch={I18n.t('searchOnlyByClientName')}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getOverdueClients: ({
    page,
    limit,
    orderBy,
    search,
  }) => dispatch(getOverdueClients({
    page,
    limit,
    orderBy,
    search,
  })),
});

const mapStateToProps = state => ({
  companyTag: state.settings.companyTag,
  overdueClients: state.overdueClients,
});

export default connect(mapStateToProps, mapDispatchToProps)(OverdueClients);
